import React from "react";
import "../../../../sass/files/family.scss";

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4.2" />
    <circle cx="17.5" cy="6.5" r="1.1" className="family-svg-fill" />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      className="family-svg-fill"
      d="M14.2 21v-8h2.7l.4-3h-3.1V8.1c0-.9.3-1.5 1.6-1.5h1.7V3.9c-.8-.1-1.5-.2-2.2-.2-2.2 0-3.7 1.3-3.7 3.8V10H9.2v3h2.4v8h2.6Z"
    />
  </svg>
);

const Family = () => {
  const openSocial = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div>
      <section className="hero">
        <div className="hero-body">
          <div className="flex flex-col gap-4 lg:flex-row">
            <div className="basis-1/2 text-center sm:text-left">
              <p className="family-community-label">
                OUR COMMUNITY
              </p>

              <p className="family-title text-center sm:text-left">
                Join the Family
              </p>

              <p className="family-subtitle mt-6 lg:w-96 sm:w-80 pb-6">
                Follow our latest custom sculpts, discover behind-the-scenes
                content and connect with people who share a passion for 3D
                printing.
              </p>
            </div>

            <div className="basis-1/2">
              <div className="w-full flex">
                <div
                  onClick={() =>
                    openSocial("https://www.instagram.com/_3dspot/")
                  }
                  className="basis-1/2 flex justify-end"
                  role="link"
                  tabIndex={0}
                >
                  <div className="family-social-item cursor-pointer">
                    <div className="family-social-icon instagram-icon">
                      <InstagramIcon />
                    </div>

                    <p className="family-social-title instagram-title">
                      Instagram
                    </p>

                    <p className="family-social-description">
                      Follow our latest sculpts and behind-the-scenes work.
                    </p>
                  </div>
                </div>

                <div
                  onClick={() =>
                    openSocial("https://www.facebook.com/3dspotted")
                  }
                  className="basis-1/2 flex justify-end"
                  role="link"
                  tabIndex={0}
                >
                  <div className="family-social-item cursor-pointer">
                    <div className="family-social-icon facebook-icon">
                      <FacebookIcon />
                    </div>

                    <p className="family-social-title facebook-title">
                      Facebook
                    </p>

                    <p className="family-social-description">
                      Join and connect with the 3D Spot community.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Family;